import {
    useEffect, useCallback, useState,
} from 'react'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

export default function useInitValue(
    value: Record<string, any>[],
): [Record<string, any>[], () => void] {
    const [
        initValue,
        setInitValue,
    ] = useState(null)

    useEffect(() => {
        if (!isEmpty(value) && isEmpty(initValue) && !isEqual(value, initValue)) {
            setInitValue(value)
        }
    }, [
        initValue,
        setInitValue,
        value,
    ])

    const discardInitValue = useCallback(() => {
        setInitValue(null)
    }, [setInitValue])

    return [
        initValue,
        discardInitValue,
    ]
}
